var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"offer-card-exclusive-label"},[_c('span',{staticClass:"offer-card-exclusive-label__text"},[_vm._v(_vm._s(_vm.$t('offerCard.exclusiveLabel')))]),_vm._v(" "),_c('IconAlaoSmile',{staticClass:"offer-card-exclusive-label__icon"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }